const NotificationItemIcon = ({aspects} : {aspects?:string}) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    aria-hidden="true"
    role="img"
    className="iconify iconify--ph  stroke-primary-500 stroke-[1.6px] text-primary-500 transition-[stroke] duration-300"
    width={aspects || "1em"}
    height={aspects || "1em"}
    viewBox="0 0 256 256"
  >
    <g fill="currentColor">
      <path
        d="M224 60a28 28 0 1 1-28-28a28 28 0 0 1 28 28"
        opacity=".2"
      ></path>
      <path d="M216 128v80a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V56a16 16 0 0 1 16-16h80a8 8 0 0 1 0 16H48v152h152v-80a8 8 0 0 1 16 0m16-68a36 36 0 1 1-36-36a36 36 0 0 1 36 36m-16 0a20 20 0 1 0-20 20a20 20 0 0 0 20-20"></path>
    </g>
  </svg>
)
}

export default NotificationItemIcon